import { useQuery } from '@tanstack/react-query'
import { fetchTestimonials } from '../api/testimonials'

const FALLBACK_TESTIMONIALS = [
  {
    id: 1,
    client_name:  'Sarah M.',
    client_role:  'Happy Parent',
    review_text:  "They made my son's day unforgettable. Everything was perfectly organized — the decoration, the characters, the music. I didn't have to worry about a single thing!",
    client_emoji: '😊',
    rating:       5,
  },
  {
    id: 2,
    client_name:  'Ahmed K.',
    client_role:  'Happy Parent',
    review_text:  'Professional team, amazing decoration, and the kids had so much fun! The puppet show and magician were a huge hit. Worth every penny.',
    client_emoji: '😊',
    rating:       5,
  },
  {
    id: 3,
    client_name:  'Nadia R.',
    client_role:  'Happy Parent',
    review_text:  'Creative, professional, and so much fun! The decoration was beyond our expectations and every child left with a big smile. We will definitely book again.',
    client_emoji: '😊',
    rating:       5,
  },
]

export function useTestimonials() {
  const query = useQuery({
    queryKey: ['testimonials'],
    queryFn: fetchTestimonials,
    staleTime: 10 * 60 * 1000,
    retry: 1,
    placeholderData: FALLBACK_TESTIMONIALS,
  })

  return {
    ...query,
    data: query.data ?? FALLBACK_TESTIMONIALS,
  }
}

export { FALLBACK_TESTIMONIALS }
